module.exports = __webpack_public_path__ + "media/yjgcc.f80bd8f4.mp4";